import { Box, Container, Typography } from "@mui/material";
import HandshakeIcon from "@mui/icons-material/Handshake";
import TuneIcon from "@mui/icons-material/Tune";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import AppsIcon from "@mui/icons-material/Apps";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import ForumIcon from "@mui/icons-material/Forum";
import AndroidIcon from '@mui/icons-material/Android';
import DepartureBoardIcon from "@mui/icons-material/DepartureBoard";
import AssistantDirectionIcon from "@mui/icons-material/AssistantDirection";
import LocalParkingIcon from '@mui/icons-material/LocalParking';

export default function HomePagePublic() {
  const infoCards = [
    {
      icon: <HandshakeIcon sx={{ fontSize: 40, color: "#1976d2" }} />,
      title: "Kooperation",
      text: "Einladung zur Zusammenarbeit für Busverkehrsunternehmen."
    },
    {
      icon: <TuneIcon sx={{ fontSize: 40, color: "#1976d2" }} />,
      title: "Anpassbar",
      text: "Individuell auf die Anforderungen Ihres Verkehrsunternehmens abgestimmt."
    },
    {
      icon: <PictureAsPdfIcon sx={{ fontSize: 40, color: "#1976d2" }} />,
      title: "PDF‑Konvertierung",
      text: "Automatische Umwandlung von Fahrplan‑PDFs inkl. aller wichtigen Informationen."
    },
    {
      icon: <AppsIcon sx={{ fontSize: 40, color: "#1976d2" }} />,
      title: "Apps & Echtzeit",
      text: "infogig ist eine Mehrzweck‑App, läuft auf allen Plattformen und zeigt alle wichtigen Infos für Mitarbeitende im Unternehmen."
    },
    {
      icon: <AndroidIcon sx={{ fontSize: 40, color: "#1976d2" }} />,
      title: "Apps & Echtzeit",
      text: "StopsIndicator: Android-App; Echtzeit‑Ansicht mit Haltestellen, Ablösen, Leerfahrten, Linienwechsel u. v. m."
    },
    {
      icon: <AltRouteIcon sx={{ fontSize: 40, color: "#1976d2" }} />,
      title: "Umleitungen & Betrieb",
      text: "Sehr wichtige Infos zu Umleitungen und betrieblichen Hinweisen."
    },
    {
      icon: <ForumIcon sx={{ fontSize: 40, color: "#1976d2" }} />,
      title: "Eine App für Kommunikation",
      text: "Zentrale Kommunikation mit Mitarbeitenden im Unternehmen."
    },
    {
      icon: <LocalParkingIcon sx={{ fontSize: 40, color: "#1976d2" }} />,
      title: "Eine App mit Parkplatz‑Infos",
      text: "Zentrale Informationen zu verfügbaren Parkplätzen mit Status Infos für Busse im Unternehmen."
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 6, px: { xs: 3, sm: 3, md: 4 } }}>
      {/* Title part */}
      <Box
        sx={{
          p: 3,
          mb: 3,
          borderRadius: 2,
          bgcolor: "#f7f9fc",
          border: "1px solid #e0e0e0",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          display: "flex",
          flexDirection: "column",
          gap: 1,
          position: "relative",
          width: "100%",
          maxWidth: { xs: 320, sm: "100%" },
          mx: { xs: "auto", sm: 0 },
          boxSizing: "border-box"
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <AssistantDirectionIcon sx={{ fontSize: 42, color: "#2f884a" }} />
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            infogig.link — Angebot
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body1" sx={{ color: "#444" }}>
            Programmierdienstleistungen für Unternehmen, die ÖPNV anbieten.
          </Typography>
          <AssistantDirectionIcon
            sx={{
              fontSize: 42,
              color: "#2f884a",
              transform: "scaleX(-1)"
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
          gap: 2,
          justifyItems: { xs: "center", sm: "stretch" }
        }}
      >
        {infoCards.map((c, idx) => (
          <Box
            key={idx}
            sx={{
              p: 3,
              borderRadius: 2,
              bgcolor: "#f7f9fc",
              border: "1px solid #e0e0e0",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              display: "flex",
              flexDirection: "column",
              gap: 1,
              position: "relative",
             width: "100%",
             maxWidth: { xs: 320, sm: "100%" },
              boxSizing: "border-box"
            }}
          >
            <DepartureBoardIcon
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                fontSize: 28,
                color: "#2f884aff"
              }}
            />
            {c.icon}
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {c.title}
            </Typography>
            <Typography variant="body1" sx={{ color: "#444" }}>
              {c.text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Container>
  );
}